















import { Component, Vue } from 'vue-property-decorator';
import Card from '@/components/Card.vue';
import CardInfo from '@/components/CardInfo.vue';
import restService from '../services/rest.service';
import wizardService from '../services/wizard.service';
import moment from 'moment';
import { IWizardItem, IWizard } from '@thefirstspine/types-arena';
import optionsService from '../services/options.service';

@Component({
  components: {
    Card,
    CardInfo,
  },
})
export default class Home extends Vue {

  public async mounted() {
    const wizzard: IWizard = await wizardService.getMe();
    const coinItem: IWizardItem|undefined = wizzard.items.find((i) => i.name === 'coin');
    this.$data.account = wizzard;
    if (coinItem) {
      this.$data.coins = coinItem.num;
    }
  }

  public data() {
    return {
      account: null,
      coins: 0,
      options: optionsService.options,
    };
  }

}
